/**
 *
 * Header Admin Mandu
 *
 */

import React, { Fragment } from "react"

import { Divider } from "antd"
import { NavLink } from "react-router-dom"
import img from "images/brand/Mandu_white.svg"
import iconCompanies from "images/HeaderIcons/Companies.svg"
import iconSupport from "images/HeaderIcons/Support.svg"
import iconAdmin from "images/HeaderIcons/Admin.svg"
import UserHeaderBox from "containers/UserHeaderBox"
import { ROLE_MANDU_ADMIN , ROLE_SUPPORT} from "../../../utils/constants"
import { LOCAL_ACTIVE_ROL,LOCAL_USER_ROLES } from "../../../utils/storage"

class AdminMandu extends React.Component {
  roleSupport = () =>{
    const userRoles = JSON.parse(LOCAL_USER_ROLES())
    const hasAccess = userRoles.some(role => role.id === 7)
    return hasAccess;
  }

  render() {
    return (
      <div className="container-header">
        <div className="container-header__left">
          <Fragment>
            <img width={80} src={img} className="container-header__logo" />
            <Divider type="vertical" />
            <NavLink
              className="container-header__left-item"
              activeClassName="container-header-active"
              to="/companies">
              <img src={iconCompanies} />
              Empresas
            </NavLink>
            {LOCAL_ACTIVE_ROL() != ROLE_MANDU_ADMIN.toString() && (
              <Fragment>
                <Divider type="vertical" />
                <NavLink
                  className="container-header__left-item"
                  activeClassName="container-header-active"
                  to="/users">
                  <img src={iconAdmin} />
                  Usuarios
                </NavLink>
              </Fragment>
            )}
             {LOCAL_ACTIVE_ROL() != ROLE_MANDU_ADMIN.toString()  && this.roleSupport() && (
              <Fragment>
                <Divider type="vertical" />
                <NavLink
                  className="container-header__left-item"
                  activeClassName="container-header-active"
                  to="/support">
                  <img src={iconSupport} />
                  Soporte
                </NavLink>
              </Fragment>
            )}
          </Fragment>
        </div>
        <div className="container-header__right">
          <UserHeaderBox />
        </div>
      </div>
    )
  }
}

AdminMandu.propTypes = {}

export default AdminMandu
